"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disclaimer = void 0;
var AcceptFlowContextProvider_1 = require("@CommonFrontend/AcceptFlow/AcceptFlowContextProvider");
var TokenRenderer_1 = __importDefault(require("@CommonFrontend/ContentTokens/TokenRenderer"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./Disclaimer.css"));
var Disclaimer = function () {
    var _a, _b;
    var settings = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)().settings;
    var text = (0, TokenRenderer_1.default)((_b = (_a = settings.disclaimer) === null || _a === void 0 ? void 0 : _a.tokens) !== null && _b !== void 0 ? _b : []);
    return (react_1.default.createElement(kaleidoscope_1.FormCheckbox, { name: "disclaimerAccepted", label: react_1.default.createElement("div", { className: styles.disclaimerText, dangerouslySetInnerHTML: { __html: text }, onClick: function (event) {
                if (event.target.tagName === "A") {
                    event.stopPropagation();
                }
            } }), validate: function (value) {
            if (!value) {
                return "Please indicate that you agree to the terms and conditions to accept the quote";
            }
        } }));
};
exports.Disclaimer = Disclaimer;
